import { ActivatedRoute, Router } from '@angular/router';
import { SelectList } from 'src/app/models/selectlist';
import { CombosService } from 'src/app/services/combos.service';
import { Component, OnInit} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FichaCadastro } from 'src/app/models/ficha-cadastro';
import { environment } from 'src/environments/environment';
import { CepService } from 'src/app/services/cep.service';
import { Criptografar } from 'src/app/util/criptografar';
import { Endereco } from 'src/app/models/endereco';
import { Deficiencia } from 'src/app/models/deficiencia';
import { Instituicao } from 'src/app/models/instituicao';
import { Telefone } from 'src/app/models/telefone';
import { Documentos } from 'src/app/models/documentos';
import { Acesso } from 'src/app/models/acesso';
import { UtilService } from 'src/app/services/util.service';
import * as moment from 'moment';

import { Validacoes } from 'src/app/models/validacoes';

@Component({
  selector: 'app-fichainscricao',
  templateUrl: './fichainscricao.component.html',
  styleUrls: ['./fichainscricao.component.css'],
})
export class FichainscricaoComponent implements OnInit {

  fichaInscricaoForm!: FormGroup;
  fichaInscricao: FichaCadastro;

  msgAlert = environment.campoObrigatorio;
  msgEmail = environment.campoEmail;
  msgTelefone = environment.campoTelefone;
  msgAlertTurno: String = '';
  msgAlertDataNascimentoInvalida: String = '';
  msgAlertDataExpedicaoInvalida: String = '';

  public msgAlertEndereco : string = '';
  public msgAlertCotista : string = '';

  listaComboDeficiencia!: SelectList[];
  listaComboInstituicao!: SelectList[];
  listaComboMes!: SelectList[];
  listaComboPais!: SelectList[];
  listaComboTurno!: SelectList[];
  listaComboFederacao!: SelectList[];
  listaRadioCotista!: SelectList[];
  listaComboSexo!: SelectList[];
  listaComboEscrita!: SelectList[];
  listaComboCienciaConcurso!: SelectList[];
  listaRadioNecessEspecial!: SelectList[];

  isTipoDeficiencia!: boolean;
  isReadOnly!: boolean;
  isAutorizaSMS!: boolean;
  isEmpityTelefone: boolean = true;
  isExibeOpcaoCotista!: boolean;
  isCotista!: boolean;
  error: any = { isError: false, errorMessage: '' };

  instituicao!: Instituicao;
  endereco!: Endereco;
  telefone!: Telefone;
  deficiencia!: Deficiencia;
  documentos!: Documentos[];
  indIsentoIR: string = '';
  indDesempregado: string = '';

  public dtoAcesso!: Acesso;

  public mostrarMsg : boolean = false;

  public tamanhoTelInvalido : boolean = false;

  get fichaInsc(): any {
    return this.fichaInscricaoForm.controls;
  }

  constructor(
    private combosService: CombosService,
    private router: Router,
    private cepService: CepService,
    private route: ActivatedRoute,
    protected utilService: UtilService
  ) {
    this.fichaInscricao = new FichaCadastro();
    this.dtoAcesso = new Acesso();
  }

  ngOnInit(): void {

    this.utilService.showLoading();

    this.fichaInscricaoForm = new FormGroup({
      codTpCotista: new FormControl(null),
      nome: new FormControl(null, [
        Validators.required,
        Validators.maxLength(60),
      ]),
      pai: new FormControl(null, [
        Validators.maxLength(60),
      ]),
      mae: new FormControl(null, [
        Validators.required,        
        Validators.maxLength(60),
      ]),
      rg: new FormControl(null, [
        Validators.required,
        Validators.maxLength(15),
      ]),
      rgOrgao: new FormControl(null, [
        Validators.required,
        Validators.maxLength(10),
      ]),
      rgUf: new FormControl(null),
      rgDataExp: new FormControl(null, [Validators.maxLength(10)]),
      numOAB: new FormControl(null, [Validators.maxLength(10)]),
      orgaoExpOAB: new FormControl(null),
      nacionalidade: new FormControl(''),
      naturalidade: new FormControl(''),
      dtNascimento: new FormControl(null, [
        Validators.required,
        Validators.maxLength(10),
      ]),
      sexo: new FormControl(null, [Validators.required]),
      escrita: new FormControl(null, [Validators.required]),
      codTurno: new FormControl(null, [Validators.required]),
      codTurnoFake: new FormControl(null, [Validators.required]),
      cienciaConcurso: new FormControl(null, [Validators.required]),
      instituicao: new FormControl('', [Validators.required]),
      mesColacaoGrau: new FormControl(''),
      anoColacaoGrau: new FormControl(null, [
        Validators.maxLength(4)
      ]),
      residencial: new FormControl(null, [Validators.minLength(13), Validators.maxLength(13)]),
      comercial: new FormControl(null, [Validators.minLength(13), Validators.maxLength(13)]),
      celular: new FormControl(null, [Validators.minLength(14), Validators.maxLength(14)]),
      email: new FormControl(null, [
        Validators.required,
        Validators.email,
        Validators.maxLength(50),
      ]),
      autorizaSMS: new FormControl(null),
      autorizaInfoPos: new FormControl(null),
      cep: new FormControl(null, [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(8),
      ]),
      logradouro: new FormControl(null, [
        Validators.required,
        Validators.maxLength(70),
      ]),
      numero: new FormControl(null, [
        Validators.maxLength(10),
      ]),
      complemento: new FormControl(null, [
        Validators.maxLength(40),
      ]),
      uf: new FormControl('', [Validators.required]),
      cidade: new FormControl(null, [
        Validators.required,
        Validators.maxLength(50),
      ]),
      bairro: new FormControl(null, [
        Validators.required,
        Validators.maxLength(50),
      ]),
      codigoDef: new FormControl('', [Validators.required]),
      portador: new FormControl(null, [Validators.required]),
      necessitaApoio: new FormControl(null),
      observacao: new FormControl(null, [Validators.maxLength(1000)]),
    });

    this.carregaCombos();
    this.fichaInscricaoForm.controls['naturalidade'].disable();
    this.fichaInscricaoForm.controls['codigoDef'].disable();
    this.fichaInscricaoForm.controls['observacao'].disable();

    let objCipto: Criptografar = new Criptografar();

    if (this.route.snapshot.queryParams['n'] !== undefined) {
      this.dtoAcesso = JSON.parse(objCipto.decrypt(this.route.snapshot.queryParams['n']));
      this.isExibeOpcaoCotista = (this.dtoAcesso.ind_prazoConcurso == 'LIBERAR_COTISTA');
    } 
    else {
      this.fichaInscricao = JSON.parse(objCipto.decrypt(this.route.snapshot.queryParams['session']));
      this.isExibeOpcaoCotista = (this.fichaInscricao.ind_prazoConcurso == 'LIBERAR_COTISTA');
      this.dtoAcesso.cpf = this.fichaInscricao.cpf;
      this.dtoAcesso.ind_prazoConcurso = this.fichaInscricao.ind_prazoConcurso;
      this.indIsentoIR = this.fichaInscricao.indIsentoIR
      this.indDesempregado = this.fichaInscricao.indDesempregado;
      this.documentos = this.fichaInscricao.documentos;
      this.preencherFormulario(this.fichaInscricao);
    }

    this.utilService.showLoading(false);
  }

  soNumeros(event: KeyboardEvent) {
    const pattern = /[0-9]/g;
    const inputChar = String(parseInt(event.key));
    if (!pattern.test(inputChar)) {
        event.preventDefault();// invalid character, prevent input
    }
  }

  onSubmitForm = (_formValue: any) => {

    if (this.fichaInscricaoForm.invalid) {
      return;
    }

    this.utilService.showLoading();

    const tpCotista =  this.fichaInscricaoForm.controls['codTpCotista'].value;
    if(this.isExibeOpcaoCotista && (tpCotista === null || tpCotista === '')){
        this.msgAlertCotista='Informe o tipo de cotista';
        this.fichaInscricaoForm.controls['codTpCotista'].markAsTouched();
        this.fichaInscricaoForm.controls['codTpCotista'].markAsDirty();
        this.fichaInscricaoForm.controls['codTpCotista'].setErrors({invalid:true});
        this.fichaInscricaoForm.updateValueAndValidity();
        this.hasRequired('codTpCotista');
        this.utilService.showLoading(false);
        return;
    }else{
      this.msgAlertCotista='';
    }

    const telRes = this.fichaInscricaoForm.controls['residencial'].value;
    const telCom = this.fichaInscricaoForm.controls['comercial'].value;
    const telCel = this.fichaInscricaoForm.controls['celular'].value;

    this.error = [{ error: false, erroMensagem: '' }];
    this.fichaInscricaoForm.controls['residencial'].setErrors(null);
    this.fichaInscricaoForm.controls['comercial'].setErrors(null);
    this.fichaInscricaoForm.controls['celular'].setErrors(null);

    if((telRes === null || telRes === '') &&
      (telCom === null || telCom === '' ) &&
      (telCel === null ||telCel ==='')){
        this.isEmpityTelefone=true;
        this.msgTelefone='Informe ao menos um telefone';
        this.fichaInscricaoForm.controls['residencial'].setErrors({invalid:true});
        this.fichaInscricaoForm.controls['comercial'].setErrors({invalid:true});
        this.fichaInscricaoForm.controls['celular'].setErrors({invalid:true});
        this.fichaInscricaoForm.controls['residencial'].markAsTouched();
        this.fichaInscricaoForm.controls['comercial'].markAsTouched();
        this.fichaInscricaoForm.controls['celular'].markAsTouched();
        this.fichaInscricaoForm.controls['residencial'].markAsDirty();
        this.fichaInscricaoForm.controls['comercial'].markAsDirty();
        this.fichaInscricaoForm.controls['celular'].markAsDirty();
        this.fichaInscricaoForm.updateValueAndValidity();
        this.hasRequired('residencial');
        this.hasRequired('comercial');
        this.hasRequired('celular');
        this.utilService.showLoading(false);
        return;
    }

    const autorizaSms = this.fichaInscricaoForm.controls['autorizaSMS'].value;
    if((autorizaSms != null && autorizaSms == true) && (telCel == null || telCel == '')){
      this.fichaInscricaoForm.controls['celular'].setErrors({invalid:true});
      this.fichaInscricaoForm.controls['celular'].markAsTouched();
      this.fichaInscricaoForm.controls['celular'].markAsDirty();
      this.fichaInscricaoForm.updateValueAndValidity();
      this.hasRequired('celular');
      this.msgAlert='Informe o celular quando escolher enviar SMS.';
      this.utilService.showLoading(false);
      return;
    }else{
      this.msgAlert='';
    }

    if(this.ValidarNumeroComplemento() == false){
      this.utilService.showLoading(false);
      return;
    }

    this.instituicao = {
      codigo: _formValue.instituicao,
      anoColacaoGrau: _formValue.anoColacaoGrau,
      mesColacaoGrau: _formValue.mesColacaoGrau,
    };
    this.endereco = {
      cep: _formValue.cep,
      logradouro: _formValue.logradouro,
      numero: _formValue.numero,
      complemento: _formValue.complemento,
      cidade: _formValue.cidade,
      bairro: _formValue.bairro,
      uf: _formValue.uf,
    };
    this.telefone = {
      residencial: _formValue.residencial,
      comercial: _formValue.comercial,
      celular: _formValue.celular,
    };
    this.deficiencia = {
      codigo: _formValue.codigoDef,
      portador: _formValue.portador == 'SIM' ? true : false,
      necessitaApoio: _formValue.necessitaApoio,
      observacao: _formValue.observacao,
    };
    this.documentos ? this.documentos : [];

    const fichaCad: FichaCadastro = {
      cpf: this.dtoAcesso.cpf,
      nome: _formValue.nome,
      dtNascimento: _formValue.dtNascimento,
      sexo: _formValue.sexo,
      escrita: _formValue.escrita,
      rg: _formValue.rg,
      rgOrgao: _formValue.rgOrgao,
      rgUf: _formValue.rgUf,
      rgDataExp: _formValue.rgDataExp,
      numOAB: _formValue.numOAB,
      orgaoExpOAB: _formValue.orgaoExpOAB,
      email: _formValue.email,
      pai: _formValue.pai,
      mae: _formValue.mae,
      autorizaSMS: _formValue.autorizaSMS,
      nacionalidade: _formValue.nacionalidade,
      naturalidade: _formValue.naturalidade,
      autorizaInfoPos: _formValue.autorizaInfoPos,
      codTurno: _formValue.codTurno,
      codTurnoFake: _formValue.codTurnoFake,
      cienciaConcurso: _formValue.cienciaConcurso,
      cotista: this.isCotista,
      codTpCotista: _formValue.codTpCotista,
      instituicao: this.instituicao,
      endereco: this.endereco,
      telefone: this.telefone,
      deficiencia: this.deficiencia,
      indIsentoIR: this.indIsentoIR,
      indDesempregado: this.indDesempregado,
      documentos: this.documentos,
      ind_prazoConcurso :  this.dtoAcesso.ind_prazoConcurso,
      ind_alterouTipoCotista : this.fichaInscricao.ind_alterouTipoCotista
    };

    this.utilService.showLoading(false);

    let objCripto: Criptografar = new Criptografar();
    let strAcesso = objCripto.encrypt(JSON.stringify(fichaCad));
    if(fichaCad.cotista === true && this.dtoAcesso.ind_prazoConcurso === 'LIBERAR_COTISTA'){
        this.router.navigate(['/documentos'], { queryParams: { session: strAcesso } });
    }else if(fichaCad.cotista != true && this.dtoAcesso.ind_prazoConcurso != 'LIBERAR_COTISTA'){
      this.router.navigate(['/confirmacaoinscricao'], { queryParams: { session: strAcesso } });
    }
  };

  habilitaBtnAvancar() {
    return !this.fichaInscricaoForm.valid;
  }

  carregaCombos() {

    this.combosService.preencheCombos('deficiencia').subscribe((lista: any) => {
      this.listaComboDeficiencia = lista;
    });
    this.combosService.preencheCombos('instituicao').subscribe((lista: any) => {
      this.listaComboInstituicao = lista;
    });
    this.combosService.preencheCombos('mes').subscribe((lista: any) => {
      this.listaComboMes = lista;
    });
    this.combosService.preencheCombos('pais').subscribe((lista: any) => {
      this.listaComboPais = lista;
    });
    this.combosService.preencheCombos('turno').subscribe((lista: any) => {
      this.listaComboTurno = lista;
    });
    this.combosService
      .preencheCombos('federacao', '1')
      .subscribe((lista: any) => {
        this.listaComboFederacao = lista;
      });

    this.listaRadioCotista = this.combosService.getCotista();
    this.listaComboSexo = this.combosService.getSexo();
    this.listaComboEscrita = this.combosService.getEscrita();
    this.listaComboCienciaConcurso = this.combosService.getCienciaConcurso();
    this.listaRadioNecessEspecial = this.combosService.getNecessEspecial();

  }

  habilitaCampoNaturalidade(selected: string) {
    if (selected == '1') {
      this.fichaInscricaoForm.controls['naturalidade'].enable();
    } else {
      this.fichaInscricaoForm.controls['naturalidade'].disable();
      this.fichaInscricaoForm.controls['naturalidade'].setValue('');
    }
  }

  habilitaCampoTipoDeficiencia(controlName: string) {
    if (this.fichaInscricaoForm.controls[controlName].value == 'SIM') {
      this.fichaInscricaoForm.controls['codigoDef'].enable();
      this.fichaInscricaoForm.controls['codigoDef'].setErrors({invalid:true});
      this.isTipoDeficiencia = true;
    } else {
      this.fichaInscricaoForm.controls['codigoDef'].disable();
      this.fichaInscricaoForm.controls['codigoDef'].setValue('');
      this.fichaInscricaoForm.controls['codigoDef'].setErrors({invalid:false});
      this.isTipoDeficiencia = false;
      this.msgAlert=environment.campoObrigatorio;
    }
    this.fichaInscricaoForm.controls['codigoDef'].markAsTouched();
    this.fichaInscricaoForm.controls['codigoDef'].markAsDirty();
    this.fichaInscricaoForm.updateValueAndValidity();
    this.hasRequired('codigoDef');
  }

  habilitaCampoObservacao(controlName: string, campoChamador : string = '') {    
    this.isReadOnly = this.fichaInscricaoForm.controls[controlName].value;
    let valorObs = this.fichaInscricaoForm.controls['observacao'].value;

    if ((this.isReadOnly && campoChamador == '') || (campoChamador == 'OBS' && this.isReadOnly && valorObs == '')){
      this.fichaInscricaoForm.controls['observacao'].enable();
      this.fichaInscricaoForm.controls['observacao'].setValidators(Validators.required);
      this.fichaInscricaoForm.controls['observacao'].setErrors({invalid:true});
    } else {
      if(!this.isReadOnly){
      this.fichaInscricaoForm.controls['observacao'].disable();
      this.fichaInscricaoForm.controls['observacao'].setValue('');
      this.fichaInscricaoForm.controls['observacao'].clearValidators();
      this.fichaInscricaoForm.controls['observacao'].setErrors({invalid:false})
      this.isReadOnly = false;
      }
    }
    this.fichaInscricaoForm.controls['observacao'].markAsTouched();
    this.fichaInscricaoForm.controls['observacao'].markAsDirty();
    this.fichaInscricaoForm.updateValueAndValidity();
    this.hasRequired('observacao');
  }

  hasRequired(controlName: string) {
        return this.fichaInscricaoForm.controls[controlName].errors &&
                (this.fichaInscricaoForm.controls[controlName].dirty ||
                  this.fichaInscricaoForm.controls[controlName].touched);
  }

  public tipoTelefone : string ='';
  validarTamanhoTelefone(tipo : string){
    this.tipoTelefone=tipo;
    this.msgTelefone='';
    let error : boolean = false;
    this.tamanhoTelInvalido=false;

    let valor= this.fichaInscricaoForm.controls[this.tipoTelefone].value;
    if (valor.length > 0){

      if(valor.length < 11 && valor !== null && this.tipoTelefone === 'celular'){
        error=true;
        this.msgTelefone='Telefone celular inválido';
        this.tamanhoTelInvalido=true;
      }

      if(valor.length < 10 && valor !== null && this.tipoTelefone !== 'celular'){
        error=true;
        this.msgTelefone='Telefone '+ this.tipoTelefone +' inválido';
        this.tamanhoTelInvalido=true;
      }

      if( error==true){
        this.fichaInscricaoForm.controls[this.tipoTelefone].setErrors({invalid:true});
        this.fichaInscricaoForm.controls[this.tipoTelefone].markAsTouched();
        this.fichaInscricaoForm.controls[this.tipoTelefone].markAsDirty();
        this.hasRequired(this.tipoTelefone);
        let elementReference = document.querySelector('#'+this.tipoTelefone);
        if (elementReference instanceof HTMLElement) {
            elementReference.focus();
        }
        return;
      }

    }

  }

  validarTurno() {
    let PrimeiroTurno = this.fichaInscricaoForm.controls['codTurno'].value;
    let SegundoTurno = this.fichaInscricaoForm.controls['codTurnoFake'].value;
    let campoVazio = PrimeiroTurno == '' && SegundoTurno == '';
    this.msgAlert = environment.campoObrigatorio;

    this.error = [{ error: false, erroMensagem: '' }];
    this.fichaInscricaoForm.controls['codTurno'].setErrors(null);
    this.fichaInscricaoForm.controls['codTurnoFake'].setErrors(null);

    if ((PrimeiroTurno == SegundoTurno) && !campoVazio) {
      this.msgAlertTurno = environment.campoTurno;
      this.msgAlert = '';
      this.fichaInscricaoForm.controls['codTurno'].setErrors({ invalid: true });
      this.fichaInscricaoForm.controls['codTurnoFake'].setErrors({ invalid: true });
    } else if (PrimeiroTurno == '' && SegundoTurno != '') {
      this.msgAlertTurno = this.msgAlert;
      this.fichaInscricaoForm.controls['codTurno'].setErrors({ invalid: true });
    } else if (PrimeiroTurno != '' && SegundoTurno == '') {
      this.msgAlertTurno = this.msgAlert;
      this.fichaInscricaoForm.controls['codTurnoFake'].setErrors({ invalid: true });
    } else if (campoVazio) {
      this.fichaInscricaoForm.controls['codTurno'].setErrors({ invalid: true });
      this.fichaInscricaoForm.controls['codTurnoFake'].setErrors({ invalid: true });
    }
  }

  getAddress(cep: number) {
    if (this.fichaInscricaoForm.controls['cep'].value != '' &&
        this.fichaInscricaoForm.controls['cep'].value.length == 8 ) {

      this.utilService.showLoading();
      this.cepService.buscaEndereco(cep).subscribe(
        (res) => {
          this.fichaInscricaoForm.controls['uf'].setValue(res.uf);
          this.fichaInscricaoForm.controls['cidade'].setValue(res.cidade);
          this.fichaInscricaoForm.controls['bairro'].setValue(res.bairro);
          this.fichaInscricaoForm.controls['logradouro'].setValue(
            res.logradouro
          );
          this.fichaInscricaoForm.controls['complemento'].setValue(
            res.complemento
          );
          this.fichaInscricaoForm.controls['numero'].setValue(res.numero);
        },
        () => {
          this.limparCep();
        }
      );
      this.utilService.showLoading(false);

    }else{
      this.limparCep();
    }
  }

  limparCep() {
    this.fichaInscricaoForm.controls['uf'].setValue('');
    this.fichaInscricaoForm.controls['cidade'].setValue('');
    this.fichaInscricaoForm.controls['bairro'].setValue('');
    this.fichaInscricaoForm.controls['logradouro'].setValue('');
    this.fichaInscricaoForm.controls['complemento'].setValue('');
    this.fichaInscricaoForm.controls['numero'].setValue('');
  }

  celularObrigatorio() {
    this.error = [{ error: false, erroMensagem: '' }];
    this.fichaInscricaoForm.controls['celular'].setErrors(null);
    this.msgTelefone='';

    if (this.fichaInscricaoForm.controls['autorizaSMS'].value) {

      this.isAutorizaSMS = true;

      if(this.fichaInscricaoForm.controls['celular'].value == '' || this.fichaInscricaoForm.controls['celular'].value == null){
        this.fichaInscricaoForm.controls['celular'].setErrors({ invalid: true });
        this.fichaInscricaoForm.controls['celular'].setValidators(Validators.required);
        this.hasRequired('celular');
      } 
      else {
        this.fichaInscricaoForm.controls['celular'].setErrors({ invalid: false });
        this.fichaInscricaoForm.controls['celular'].setValidators(null);
      }

      this.fichaInscricaoForm.controls['celular'].markAsTouched();
      this.fichaInscricaoForm.controls['celular'].markAsDirty();
      this.fichaInscricaoForm.controls['celular'].updateValueAndValidity();
      
    } 
    else {
      this.isAutorizaSMS = false;
      this.fichaInscricaoForm.controls['celular'].setErrors({ invalid: false });
      this.fichaInscricaoForm.controls['celular'].setValidators(null);
      this.fichaInscricaoForm.controls['celular'].updateValueAndValidity();
    }

  }

  telefoneObrigatorio() {
    this.error = [{ error: false, erroMensagem: '' }];
    this.fichaInscricaoForm.controls['residencial'].setErrors(null);
    this.fichaInscricaoForm.controls['comercial'].setErrors(null);
    this.fichaInscricaoForm.controls['celular'].setErrors(null);

    if (
      (this.fichaInscricaoForm.controls['residencial'].value == null ||
        this.fichaInscricaoForm.controls['residencial'].value == '') &&
      (this.fichaInscricaoForm.controls['comercial'].value == null ||
        this.fichaInscricaoForm.controls['comercial'].value == '') &&
      (this.fichaInscricaoForm.controls['celular'].value == null ||
        this.fichaInscricaoForm.controls['celular'].value == '')
    ) {
      this.isEmpityTelefone = false;
      this.fichaInscricaoForm.controls['residencial'].setErrors({invalid: true});
      this.fichaInscricaoForm.controls['residencial'].setValidators(Validators.required);
      this.fichaInscricaoForm.controls['comercial'].setErrors({invalid: true});
      this.fichaInscricaoForm.controls['comercial'].setValidators(Validators.required);
      this.fichaInscricaoForm.controls['celular'].setErrors({invalid: true});
      this.fichaInscricaoForm.controls['celular'].setValidators(Validators.required);
    }
    else {
      this.msgTelefone='';
      this.isEmpityTelefone = true;
      this.fichaInscricaoForm.controls['residencial'].setValidators(null);
      this.fichaInscricaoForm.controls['residencial'].setErrors({invalid: false});
      this.fichaInscricaoForm.controls['residencial'].updateValueAndValidity();

      this.fichaInscricaoForm.controls['comercial'].setValidators(null);
      this.fichaInscricaoForm.controls['comercial'].setErrors({invalid: false});
      this.fichaInscricaoForm.controls['comercial'].updateValueAndValidity();

      this.fichaInscricaoForm.controls['celular'].setValidators(null);
      this.fichaInscricaoForm.controls['celular'].setErrors({invalid: false});
      this.fichaInscricaoForm.controls['celular'].updateValueAndValidity();
    }
  }

  cotistaObrigatorio() {    
    this.error = [{ error: false, erroMensagem: '' }];
    this.fichaInscricaoForm.controls['codTpCotista'].setErrors(null);

    if (this.isExibeOpcaoCotista && this.fichaInscricaoForm.controls['codTpCotista'].value === null)
    {
      this.isCotista = false;
      this.fichaInscricaoForm.controls['codTpCotista'].setErrors({ invalid: true });
      this.fichaInscricaoForm.controls['codTpCotista'].setValidators(Validators.required);
      this.fichaInscricaoForm.controls['codTpCotista'].updateValueAndValidity();
    } else {
      if(this.isExibeOpcaoCotista){
        this.isCotista = true;
      }else{
        this.isCotista = false;
      }
      this.msgAlertCotista='';
      this.fichaInscricaoForm.controls['codTpCotista'].setErrors({ invalid: false });
      this.fichaInscricaoForm.controls['codTpCotista'].updateValueAndValidity();
    }

    if(this.fichaInscricao.codTpCotista != undefined && this.fichaInscricao.codTpCotista != ""){
      if (this.fichaInscricaoForm.controls['codTpCotista'].value != this.fichaInscricao.codTpCotista){
        this.fichaInscricao.ind_alterouTipoCotista = true;
      }else{
        this.fichaInscricao.ind_alterouTipoCotista = false;
      }
    }

  }

  ValidarNumeroComplemento() : boolean{
    let ret : boolean = true;
    const numero = this.fichaInscricaoForm.controls['numero'].value;
    const complemento = this.fichaInscricaoForm.controls['complemento'].value;

    this.error = [{ error: false, erroMensagem: '' }];
    this.fichaInscricaoForm.controls['numero'].setErrors(null);
    this.fichaInscricaoForm.controls['complemento'].setErrors(null);
    //this.msgAlert='';
    this.msgAlertEndereco='';

    if((numero == null || numero == '') && (complemento === null || complemento === '')){
        this.fichaInscricaoForm.controls['numero'].setErrors({ invalid: true });
        this.fichaInscricaoForm.controls['complemento'].setErrors({ invalid: true });
        this.msgAlertEndereco='Informe Numero e / ou complemento.';
        this.fichaInscricaoForm.updateValueAndValidity();
        this.fichaInscricaoForm.controls['complemento'].markAsTouched();
        this.fichaInscricaoForm.controls['complemento'].markAsDirty();
        this.fichaInscricaoForm.controls['numero'].markAsTouched();
        this.fichaInscricaoForm.controls['numero'].markAsDirty()
        this.hasRequired('numero');
        this.hasRequired('complemento');
        ret= false;
    }
    return ret;
  }

  preencherFormulario(fichaCad: any) {

    this.utilService.showLoading();

    this.fichaInscricao = fichaCad as FichaCadastro;

    this.fichaInscricaoForm.patchValue(this.fichaInscricao);
    this.fichaInscricaoForm.controls['numOAB'].setValue(this.fichaInscricao.numOAB);
    this.fichaInscricaoForm.controls['orgaoExpOAB'].setValue(this.fichaInscricao.orgaoExpOAB);

    this.fichaInscricaoForm.controls['instituicao'].setValue(this.fichaInscricao.instituicao.codigo);
    this.fichaInscricaoForm.controls['anoColacaoGrau'].setValue(this.fichaInscricao.instituicao.anoColacaoGrau);
    this.fichaInscricaoForm.controls['mesColacaoGrau'].setValue(this.fichaInscricao.instituicao.mesColacaoGrau);

    this.fichaInscricaoForm.controls['cep'].setValue(this.fichaInscricao.endereco.cep);
    this.fichaInscricaoForm.controls['logradouro'].setValue(this.fichaInscricao.endereco.logradouro);
    this.fichaInscricaoForm.controls['numero'].setValue(this.fichaInscricao.endereco.numero);
    this.fichaInscricaoForm.controls['complemento'].setValue(this.fichaInscricao.endereco.complemento);
    this.fichaInscricaoForm.controls['cidade'].setValue(this.fichaInscricao.endereco.cidade);
    this.fichaInscricaoForm.controls['bairro'].setValue(this.fichaInscricao.endereco.bairro);
    this.fichaInscricaoForm.controls['uf'].setValue(this.fichaInscricao.endereco.uf);

    let numTelRes = Validacoes.numeroTelefone(this.fichaInscricao.telefone.residencial);
    this.fichaInscricaoForm.controls['residencial'].setValue(numTelRes);
    if(this.fichaInscricao.telefone.residencial !== ''){
      this.fichaInscricaoForm.controls['residencial'].setErrors({ invalid: false });
      this.fichaInscricaoForm.controls['residencial'].markAsTouched();
      this.fichaInscricaoForm.controls['residencial'].markAsDirty();
    } 
    this.fichaInscricaoForm.controls['residencial'].updateValueAndValidity();

    let numTelCom = Validacoes.numeroTelefone(this.fichaInscricao.telefone.comercial);
    this.fichaInscricaoForm.controls['comercial'].setValue(numTelCom);
    if(this.fichaInscricao.telefone.comercial !== ''){
      this.fichaInscricaoForm.controls['comercial'].setErrors({ invalid: false });
      this.fichaInscricaoForm.controls['comercial'].markAsTouched();
      this.fichaInscricaoForm.controls['comercial'].markAsDirty();
    } 
    this.fichaInscricaoForm.controls['comercial'].updateValueAndValidity();

    let numCel = Validacoes.numeroTelefone(this.fichaInscricao.telefone.celular);
    this.fichaInscricaoForm.controls['celular'].setValue(numCel);
     if(this.fichaInscricao.telefone.celular !== ''){
      this.fichaInscricaoForm.controls['celular'].setErrors({ invalid: false });
      this.fichaInscricaoForm.controls['celular'].markAsTouched();
      this.fichaInscricaoForm.controls['celular'].markAsDirty();
    } 
    this.fichaInscricaoForm.controls['celular'].updateValueAndValidity();

    this.fichaInscricaoForm.controls['portador'].setValue(this.fichaInscricao.deficiencia.portador ? 'SIM' : 'NAO');
    this.habilitaCampoTipoDeficiencia('portador');
    this.fichaInscricaoForm.controls['codigoDef'].setValue(this.fichaInscricao.deficiencia.codigo ?? '');
 
    this.fichaInscricaoForm.controls['necessitaApoio'].setValue(this.fichaInscricao.deficiencia.necessitaApoio);
    this.fichaInscricaoForm.controls['observacao'].setValue(this.fichaInscricao.deficiencia.observacao);

    if(this.fichaInscricao.deficiencia.necessitaApoio===true && this.fichaInscricao.deficiencia.observacao !== '' ){
      this.fichaInscricaoForm.controls['observacao'].setErrors({ invalid: false });
      this.fichaInscricaoForm.controls['observacao'].enable();
      this.fichaInscricaoForm.controls['observacao'].markAsTouched();
      this.fichaInscricaoForm.controls['observacao'].markAsDirty();
    }
    this.fichaInscricaoForm.controls['observacao'].updateValueAndValidity();

    this.cotistaObrigatorio();
    //this.habilitaCampoObservacao('necessitaApoio');
    this.habilitaCampoNaturalidade(this.fichaInscricao.nacionalidade);

    this.fichaInscricaoForm.updateValueAndValidity();

    this.utilService.showLoading(false);

  }

  validaDataNascimento() {
      this.fichaInscricaoForm.controls['dtNascimento'].setErrors(null);
      const dtNascimento = this.fichaInscricaoForm.controls['dtNascimento'].value;

      var dataAtual = moment();
      var dataNascimento = moment(dtNascimento);

      let retornoData = dataNascimento.isSameOrAfter(dataAtual, 'day');

      if (retornoData) {
        this.msgAlertDataNascimentoInvalida = 'A data de nascimento não pode ser maior que a data atual.';
        this.fichaInscricaoForm.controls['dtNascimento'].setErrors({ invalid: true });
      } else {
        this.fichaInscricaoForm.controls['dtNascimento'].setErrors(null);
      }
  }

  validaDataExpedicao() {
    this.fichaInscricaoForm.controls['rgDataExp'].setErrors(null);
    const rgDataExp = this.fichaInscricaoForm.controls['rgDataExp'].value;

    var dataAtual = moment();
    var dataExpedicao = moment(rgDataExp);

    let retornoData = dataExpedicao.isSameOrAfter(dataAtual, 'day');

    if (retornoData) {
      this.msgAlertDataExpedicaoInvalida = 'A data de expedição da identidade não pode ser maior que a data atual.';
      this.fichaInscricaoForm.controls['rgDataExp'].setErrors({ invalid: true });
    } else {
      this.fichaInscricaoForm.controls['rgDataExp'].setErrors(null);
    }
  }

}
